"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserEventTable = GetUserEventTable;
var env_1 = require("@ca/wrap-sdk/src/env");
function GetUserEventTable() {
    return env_1.Stage.stage + "-UserEvents";
}
//# sourceMappingURL=user-event-table.js.map